export default "__VITE_ASSET__DYCxawmz__"